import React, { useState, useEffect } from "react";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import axios from "axios";
import apiConfig from '../apiConfig';

const GatewayManage = () => {
  const [inpval, setINP] = useState({
    okpay_mch_id: "",
    okpay_key: "",
    okpay_host: "",
    withdrawMode: "Auto", 
    depositMode: "Auto", 
  });

  const [loading, setLoading] = useState(false);
  const [settingId, setSettingId] = useState(null);

  useEffect(() => {
    axios.get(`${apiConfig.baseURL}/api/users/GatewaySettingGet`)
      .then((res) => {
        if (res.data) {
          setSettingId(res.data._id);
          setINP({
            okpay_mch_id: res.data.okpay_mch_id || "",
            okpay_key: res.data.okpay_key || "",
            okpay_host: res.data.okpay_host || "",
            withdrawMode: res.data.withdrawMode || "Auto", 
            depositMode: res.data.depositMode || "Auto", 
          });
        }
      })
      .catch((err) => console.error("Failed to load settings:", err));
  }, []);

  const setdata = (e) => {
    const { name, value } = e.target;
    setINP((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!inpval.okpay_mch_id) return alert("MCH ID is required");
    if (!inpval.okpay_key) return alert("OKPay Key is required");
    if (!inpval.okpay_host) return alert("OKPay Host is required");

    setLoading(true);
    try {
      const res = await axios.post(
        `${apiConfig.baseURL}/api/users/GatewaySettingUpdate`,
        inpval
      );
      if (res.status === 200) {
        alert("Gateway settings updated successfully!");
      }
    } catch (err) {
      console.error(err);
      alert("Failed to update settings.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Payment Gateway Settings</h4>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>

                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">OKPay MCH ID</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        name="okpay_mch_id"
                        className="form-control"
                        placeholder="Enter MCH ID"
                        value={inpval.okpay_mch_id}
                        onChange={setdata}
                      />
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">OKPay Secret Key</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        name="okpay_key"
                        className="form-control"
                        placeholder="Enter Secret Key"
                        value={inpval.okpay_key}
                        onChange={setdata}
                      />
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">OKPay Host URL</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        name="okpay_host"
                        className="form-control"
                        placeholder="https://api.example.com"
                        value={inpval.okpay_host}
                        onChange={setdata}
                      />
                    </div>
                  </div>

               
                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Withdraw Mode</label>
                    <div className="col-sm-9">
                      <select
                        name="withdrawMode"
                        className="form-control"
                        value={inpval.withdrawMode}
                        onChange={setdata}
                      >
                        <option value="Auto">Auto</option>
                        <option value="Manual">Manual</option>
                      </select>
                      <small className="text-muted">
                        Auto: Processed automatically. Manual: Requires admin approval.
                      </small>
                    </div>
                  </div>


                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Deposit Mode</label>
                    <div className="col-sm-9">
                      <select
                        name="depositMode"
                        className="form-control"
                        value={inpval.depositMode}
                        onChange={setdata}
                      >
                        <option value="Auto">Auto</option>
                        <option value="Manual">Manual</option>
                      </select>
                      <small className="text-muted">
                        Auto: Processed automatically. Manual: Requires admin approval.
                      </small>
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <div className="col-sm-10">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Saving..." : "Update Gateway"}
                      </button>
                    </div>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default GatewayManage;